import { IEmployee } from '@/common/integrations/menhir/employee/employee/employee.types';
import {
  IEWADetails,
  IEWADetailsWithScheduling,
} from '@/common/integrations/menhir/employee/salary/salary.types';
import { addDays, set, startOfToday, subDays } from 'date-fns';
import { now } from './date';

export const getPayrollRange = (payday: number, blockedDays: number) => {
  const today = now();
  const isAfterPayday = today.getDate() > payday;
  const paydayDate = isAfterPayday
    ? set(today, { month: today.getMonth() + 1, date: payday })
    : set(today, { date: payday });

  const startDate = subDays(paydayDate, blockedDays);

  return {
    from: startDate,
    to: paydayDate,
  };
};

export const getDaysRange = ({
  payday,
  blockedDays,
}: {
  payday: number;
  blockedDays: number;
}) => {
  const todayDate = startOfToday();
  const isAfterPayday = todayDate.getDate() > payday;
  const currentMonth = todayDate.getMonth();
  const firstDate = set(todayDate, {
    month: isAfterPayday ? currentMonth : currentMonth - 1,
    date: payday,
  });
  const lastDate = set(todayDate, {
    month: isAfterPayday ? currentMonth + 1 : currentMonth,
    date: payday,
  });

  return {
    startDate: addDays(firstDate, 1),
    endDate: subDays(lastDate, blockedDays + 1),
  };
};

export const isOneOffAvailable = (details: IEWADetails) =>
  details.modules.includes('one-off');

export const isSchedulingAvailable = (details: IEWADetails) =>
  details.modules.includes('scheduling');

export const isSchedulingActive = (
  details: IEWADetails
): details is IEWADetailsWithScheduling =>
  isSchedulingAvailable(details) && !!details.scheduling;

export const getAvailableModules = (
  details: IEWADetails
): 'one-off' | 'scheduling' | 'both' | null => {
  const oneOff = isOneOffAvailable(details);
  const scheduling = isSchedulingAvailable(details);

  if (oneOff && scheduling) return 'both';
  if (oneOff) return 'one-off';
  if (scheduling) return 'scheduling';
  return null;
};

export const areActionsEnabled = (details: IEWADetails, user: IEmployee) =>
  details.status === 'active' &&
  !details.isBlockedDay &&
  user.invitation !== 'left';
